import { api } from "@/lib/api";

export const listProspects = () => api.get("/admin/prospects").then((r) => r.data);
export const createProspect = (body) => api.post("/admin/prospects", body).then((r) => r.data);
export const updateProspect = (id, body) => api.put(`/admin/prospects/${id}`, body).then((r) => r.data);
export const convertProspect = (id, fee) => api.post(`/admin/prospects/${id}/convert`, { advertising_fee_percent: fee }).then((r) => r.data);

export const PROSPECT_STATUS = {
  new: ["New", "bg-sky-50 text-sky-800 border-sky-200"],
  contacted: ["Contacted", "bg-stone-50 text-stone-700 border-stone-200"],
  interested: ["Interested", "bg-amber-50 text-amber-800 border-amber-200"],
  ready_to_sell: ["Ready to Sell", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  not_proceeding: ["Not Proceeding", "bg-red-50 text-red-700 border-red-200"],
};
